module.exports = __webpack_public_path__ + "img/calendar.9362ff96.svg";